import FirstConfirmPage from './FirstConfirmPage';

export default FirstConfirmPage;
